<template>
  <b-form-select
    v-model="local_value"
    :options="options"
    v-bind="$props"
  ></b-form-select>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    options: [
      {
        text: "Revisado",
        value: "Revisado"
      },
      {
        text: "Não Revisado",
        value: "Não Revisado"
      },
      {
        text: "Não encontrado",
        value: "Não encontrado"
      }
    ],
  }),
  computed: {
    local_value: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>
